/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for anypurpose without the express written permission of Honeywell. */
import {
  Autocomplete,
  AutocompleteRenderOptionState,
  Avatar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Checkbox,
  FormLabel,
  LinearProgress,
  MenuItem,
  Paper,
  Select,
  Typography,
  OutlinedInput,
  FormHelperText,
  Tooltip,
  Grid,
  TextField,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useEffect, useState, useRef } from "react";

import classes from "./CreateTenantPage.module.css";
import IFile from "../Image/types/File";
import useInput from "../../hooks/user-input";
import { useNavigate } from "react-router-dom";
import Loader from "../Loader/Loader";
import EditIcon from "@mui/icons-material/Edit";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import editLogo from "./EditLogo.png";
import {
  CreateorEditTenantDto,
  IErrorProps,
  MappingCountry,
  MappingRegion,
  MappingState,
  OptionsProduct,
  OptionsTimeZone,
} from "../../models";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import {
  createTenantDetails,
  getAvailableCurrencies,
  getAvailableDataCenters,
  getAvailableProducts,
  getAvailableTimeZones,
  getGeoMapping,
  uploadTenantLogoDetails,
} from "../../store/Tenant/tenant-actions";
import updateErrorList from "../../utils/methods/updateErrorList";
import DialogForError from "../SharedComponents/DialogForError";
import ToastBarForError from "../SharedComponents/ToastBarForError";
import GeoMapping from "../../models/apiModels/GeoMapping";

function CreateTenantPage() {
  const commonStyles = {
    bgcolor: "background.paper",
    borderColor: "text.primary",
    m: 1,
    border: 1,
    width: "10rem",
    height: "10rem",
  };

  const TenantNameRegex = /^[a-zA-Z\s]*$/; // Only allows alphanumeric characters
  const OrgNameRegex = /^[a-zA-Z0-9_\s\.\-]*$/; // Only allows alphanumeric characters
  const AddressRegex = /^[a-zA-Z0-9,\s\.\-]*$/; // Only allows alphanumeric characters
  const forgeCustomerIdRegex = /^([.,a-zA-Z0-9 _-]+)$/;
  const [isForgeCustomerIdRegexMatched, setIsForgeCustomerIdRegexMatched] =
    useState<boolean>(true);
  const [openDialogNoURLError, setOpenDialogNoURLError] = useState(false);
  const [openDialogServerError, setOpenDialogServerError] = useState(false);
  const [openToastError, setOpenToastError] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [hasValidForgeCustomerId, setHasValidForgeCustomerId] =
    useState<boolean>(true);
  const [invalidForgeCustomerId, setInvalidForgeCustomerId] =
    useState<string>("");

  const handleIconClick = () => {
    fileInputRef.current?.click();
  };
  const backButtonHandler = () => {
    navigate("/tenant");
  };
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  const [selectedApplications, setSelectedApplications] = useState<
    OptionsProduct[]
  >([]);

  const [enteredApp, setEnteredApp] = useState<Array<string>>([]);
  useEffect(() => {
    const selectedApp = selectedApplications?.map(
      (selectedApplication) => selectedApplication.applicationId
    );
    setEnteredApp(selectedApp);
  }, [selectedApplications]);

  const [allSelected, setAllSelected] = useState(false);
  // istanbul ignore next
  //for handelling select all feature
  const handleApplicationSelection = (
    event: React.ChangeEvent<{}>,
    selectedOptions: OptionsProduct[]
  ) => {
    if (
      selectedOptions &&
      selectedOptions.find((option) => option.applicationId == "selectAll")
    ) {
      if (
        //coverity
        selectedOptions !== null &&
        selectedOptions.length == optionsProduct.length
      ) {
        setSelectedApplications([]);
        setAllSelected(false);
        setIsTouched(true);
      } else {
        setSelectedApplications(optionsProduct.slice(1));
        setAllSelected(true);
        setIsTouched(true);
      }
    } else {
      if (selectedOptions.length == optionsProduct.length - 1) {
        setAllSelected(true);
      } else {
        setAllSelected(false);
      }
      setSelectedApplications(selectedOptions);
      setIsTouched(true);
    }
  };
  const [isTouched, setIsTouched] = useState(false);
  const [optionsProduct, setOptionsProduct] = useState<Array<OptionsProduct>>(
    []
  );
  const [isLoading, setIsLoading] = useState(false);
  const [errorList, setErrorList] = useState<Array<IErrorProps>>([]);
  // Error lists
  const [errorAvailableDatacentre, seterrorAvailableDatacentre] = useState<
    Array<IErrorProps>
  >([]);
  const [errorGeoMapping, seterrorGeoMapping] = useState<Array<IErrorProps>>(
    []
  );
  const [errorAvailableTimezone, seterrorAvailableTimezone] = useState<
    Array<IErrorProps>
  >([]);
  const [errorAvailableCurrency, seterrorAvailableCurrency] = useState<
    Array<IErrorProps>
  >([]);
  const [errorAvailableProducts, seterrorAvailableProducts] = useState<
    Array<IErrorProps>
  >([]);
  const [errorCreateCustomer, seterrorCreateCustomer] = useState<
    Array<IErrorProps>
  >([]);
  const [errorLogo, seterrorLogo] = useState<Array<IErrorProps>>([]);
  // End error lists
  const {
    value: enteredTenantName,
    isValid: enteredTenantNameIsValid,
    hasError: enteredTenantHasError,
    onSubmitError: enteredTenantOnSubmitError,
    valueChangeHandler: tenantNameChangeHandler,
    inputBlurHandler: tenantNameBlurHandler,
    onSubmitHandler: tenantSubmitHandler,
    regexError: regexhasError,
  } = useInput((value: any) => value.trim() !== "");
  const [enteredProduct, setProduct] = useState<string[]>([]);

  const {
    value: enteredheadquarterAddress,
    isValid: enteredheadquarterAddressIsValid,
    hasError: enteredheadquarterAddressHasError,
    onSubmitError: enteredheadquarterAddressOnSubmitError,
    valueChangeHandler: enteredheadquarterAddressChangeHandler,
    inputBlurHandler: enteredheadquarterAddressBlurHandler,
    onSubmitHandler: enteredheadquarterAddressSubmitHandler,
    regexError: regexhasErrorHeadquater,
  } = useInput((value: any) => value.trim() !== "");

  const {
    value: enteredForgeCustomerId,
    isValid: enteredForgeCustomerIdIsValid,
    hasError: enteredForgeCustomerIdHasError,
    onSubmitError: enteredForgeCustomerIdOnSubmitError,
    valueChangeHandler: enteredForgeCustomerIdChangeHandler,
    inputBlurHandler: enteredForgeCustomerIdBlurHandler,
    onSubmitHandler: enteredForgeCustomerIdSubmitHandler,
    regexError: regexhasErrorForge,
  } = useInput((value: any) => value.trim() !== "");

  const {
    value: enteredCurrency,
    isValid: enteredCurrencyIsValid,
    hasError: enteredCurrencyHasError,
    onSubmitError: enteredCurrencySubmitError,
    valueChangeHandler: enteredCurrencyChangeHandler,
    inputBlurHandler: enteredCurrencyBlurHandler,
    onSubmitHandler: enteredCurrencySubmitHandler,
  } = useInput((value: any) => value !== "");

  const {
    value: enteredTimeZone,
    isValid: enteredTimeZoneIsValid,
    hasError: enteredTimeZoneHasError,
    onSubmitError: enteredTimeZoneSubmitError,
    valueChangeHandler: enteredTimeZoneChangeHandler,
    inputBlurHandler: enteredTimeZoneBlurHandler,
    onSubmitHandler: enteredTimeZoneSubmitHandler,
    reset: resetEnteredTimeZone,
  } = useInput((value: any) => value !== "");

  const {
    value: enteredDatacenter,
    isValid: enteredDatacenterIsValid,
    hasError: enteredDatacenterHasError,
    onSubmitError: enteredDatacenterSubmitError,
    valueChangeHandler: enteredDatacenterChangeHandler,
    inputBlurHandler: enteredDatacenterBlurHandler,
    onSubmitHandler: enteredDatacenterSubmitHandler,
  } = useInput((value: any) => value !== "");

  const {
    value: enteredState,
    isValid: enteredStateIsValid,
    hasError: enteredStateHasError,
    onSubmitError: enteredStateSubmitError,
    valueChangeHandler: enteredStateChangeHandler,
    inputBlurHandler: enteredStateBlurHandler,
    onSubmitHandler: enteredStateSubmitHandler,
    reset: resetEnteredState,
  } = useInput((value: any) => value !== "");

  const {
    value: enteredCountry,
    isValid: enteredCountryIsValid,
    hasError: enteredCountryHasError,
    onSubmitError: enteredCountrySubmitError,
    valueChangeHandler: enteredCountryChangeHandler,
    inputBlurHandler: enteredCountryBlurHandler,
    onSubmitHandler: enteredCountrySubmitHandler,
    reset: resetEnteredCountry,
  } = useInput((value: any) => value !== "");

  const [isCountryDisabled, setIsCountryDisabled] = useState(true);
  const [isStateDisabled, setIsStateDisabled] = useState(true);
  const [isTimeZoneDisabled, setIsTimeZoneDisabled] = useState(true);

  const {
    value: enteredRegion,
    isValid: enteredRegionIsValid,
    hasError: enteredRegionHasError,
    onSubmitError: enteredRegionSubmitError,
    valueChangeHandler: enteredRegionChangeHandler,
    inputBlurHandler: enteredRegionBlurHandler,
    onSubmitHandler: enteredRegionSubmitHandler,
  } = useInput((value: any) => value !== "");

  const {
    value: enteredOrganizationName,
    valueChangeHandler: enteredOrganizationNameChangeHandler,
    inputBlurHandler: enteredOrganizationNameBlurHandler,
    onSubmitHandler: enteredOrganizationNameSubmitHandler,
    regexError: regexhasErrorOrgName,
  } = useInput((value: any) => value !== "");

  const {
    value: enteredZipcode,
    valueChangeHandler: enteredZipcodeChangeHandler,
    inputBlurHandler: enteredZipcodeBlurHandler,
    onSubmitHandler: enteredZipcodeSubmitHandler,
    regexError: regexhasErrorZipCode,
  } = useInput((value: any) => value !== "");

  const optionsDataCenter = useSelector(
    (state: RootState) => state.cart.availableDataCentres
  );
  // istanbul ignore next

  useEffect(() => {
    const mergedErrors = [
      ...errorAvailableDatacentre,
      ...errorAvailableTimezone,
      ...errorAvailableCurrency,
      ...errorAvailableProducts,
      ...errorGeoMapping,
      ...errorCreateCustomer,
      ...errorLogo,
    ];

    if (
      mergedErrors.some((x) => x.errorCode === undefined) &&
      !openDialogNoURLError
    ) {
      setOpenDialogNoURLError(true);
    }
    if (mergedErrors.some((x) => x.errorCode === 400) && !openToastError) {
      setOpenToastError(true);
    }
    if (
      mergedErrors.some(
        (x) =>
          x.errorCode !== undefined &&
          x.errorCode !== 400 &&
          x.errorCode !== null &&
          x.errorCode !== 204
      ) &&
      !openDialogServerError
    ) {
      setOpenDialogServerError(true);
    }
    setErrorList(mergedErrors);
  }, [
    errorAvailableCurrency,
    errorAvailableTimezone,
    errorAvailableDatacentre,
    errorAvailableProducts,

    errorCreateCustomer,
    errorGeoMapping,
    errorLogo,
  ]);

  const optionstimeZone = useSelector(
    (state: RootState) => state.cart.availableTimeZones
  );
  const optionsCurrency = useSelector(
    (state: RootState) => state.cart.availableCurrencies
  );
  const optionsGeoMapping: GeoMapping = useSelector(
    (state: RootState) => state.cart.geoMapping
  );

  const optionsProductList = useSelector(
    (state: RootState) => state.cart.availableProducts
  );
  // Get Datacentres if not present
  useEffect(() => {
    if (optionsCurrency?.length === 0) {
      setIsLoading(true);
      dispatch(getAvailableDataCenters())
        .unwrap()
        .then(() => {})
        .catch((error: any) => {
          seterrorAvailableDatacentre(
            updateErrorList(error, [...errorAvailableDatacentre])
          );
        })
        .finally(() => setIsLoading(false));
    }
  }, []);
  // Get Geo mapping
  useEffect(() => {
    if (optionsGeoMapping?.countryDataMap?.length === 0) {
      setIsLoading(true);
      dispatch(getGeoMapping())
        .unwrap()
        .then(() => {})
        .catch((error: any) => {
          seterrorGeoMapping(updateErrorList(error, [...errorGeoMapping]));
        })
        .finally(() => setIsLoading(false));
    }
  }, []);

  // Get Timezones if not present
  useEffect(() => {
    if (optionstimeZone?.length === 0) {
      setIsLoading(true);
      dispatch(getAvailableTimeZones())
        .unwrap()
        .then(() => {})
        .catch((error: any) => {
          seterrorAvailableTimezone(
            updateErrorList(error, [...errorAvailableTimezone])
          );
        })
        .finally(() => setIsLoading(false));
    }
  }, []);
  // Get currencies if not present
  useEffect(() => {
    if (optionsCurrency?.length === 0) {
      setIsLoading(true);
      dispatch(getAvailableCurrencies())
        .unwrap()
        .then(() => {})
        .catch((error: any) => {
          seterrorAvailableCurrency(
            updateErrorList(error, [...errorAvailableCurrency])
          );
        })
        .finally(() => setIsLoading(false));
    }
  }, []);
  // Get available products if not present
  useEffect(() => {
    if (optionsProductList?.length === 0) {
      setIsLoading(true);
      dispatch(getAvailableProducts())
        .unwrap()
        .then(() => {})
        .catch((error: any) => {
          seterrorAvailableProducts(
            updateErrorList(error, [...errorAvailableProducts])
          );
        })
        .finally(() => setIsLoading(false));
    }
  }, []);

  ///Get API calls done
  useEffect(() => {
    let prodOptions: OptionsProduct[] = [
      { applicationId: "selectAll", applicationName: "Select All" },
    ];
    prodOptions = prodOptions.concat(optionsProductList);
    setOptionsProduct(prodOptions);
  }, [optionsProductList]);
  useEffect(() => {
    const selectedApp = selectedApplications?.map(
      (selectedApps) => selectedApps.applicationId
    );
    setEnteredApp(selectedApp);
  }, [selectedApplications]);
  const [cancelOpen, setCancelOpen] = useState(false);
  const [createOpen, setCreateOpen] = useState(false);

  const [currentImage, setCurrentImage] = useState<File>();
  const [previewImage, setPreviewImage] = useState<string>("");
  const [progress, setProgress] = useState<number>(0);
  const [message, setMessage] = useState<string>("");
  const [imageInfos, setImageInfos] = useState<Array<IFile>>([]);
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();

  const checkIfAnyTextFilled = () => {
    if (
      enteredTenantName === "" &&
      enteredheadquarterAddress === "" &&
      // enteredApplication === "" &&
      enteredTimeZone === "" &&
      enteredDatacenter === "" &&
      enteredCurrency === "" &&
      enteredForgeCustomerId === "" &&
      enteredCountry === "" &&
      enteredRegion === ""
    ) {
      if (enteredState === "" && !isStateDisabled) {
        return true;
      } else if (isStateDisabled) {
        return true;
      } else {
      }

      return false;
    } else return false;
  };

  const confirmCancelHandller = () => {
    setCancelOpen(false);
    navigate("/tenant");
  };

  const getCountryNameById = (countryId: string): string | undefined => {
    const country = countryMapping.find((c) => c.countryId === +countryId);
    return country?.countryName;
  };

  const getRegionById = (RegionId: string): string | undefined => {
    const region = regionMapping.find((c) => c.regionId === +RegionId);
    return region?.regionName;
  };

  const getStateById = (StateId: string): string | undefined => {
    const region = stateMapping.find((c) => c.stateId === +StateId);
    return region?.stateName;
  };

  const getDataCenterById = (datacenterId: string): string | undefined => {
    const dataCenter = optionsDataCenter.find(
      (c) => c.datacenterId === datacenterId
    );
    return dataCenter?.datacenterName;
  };

  const getCurrencyById = (currencyId: string): string | undefined => {
    const currency = optionsCurrency.find((c) => c.currencyId === currencyId);
    return currency?.currencyName;
  };

  const getTimeZoneById = (timezoneId: string): string | undefined => {
    const timeZone = optionstimeZone.find((c) => c.timezoneId === timezoneId);
    return timeZone?.timezoneName;
  };

  function validate() {
    if (enteredProduct.length == 0) {
      setIsTouched(true);
    }
    if (
      !enteredheadquarterAddressIsValid ||
      !enteredTenantNameIsValid ||
      !enteredCurrencyIsValid ||
      !enteredTimeZoneIsValid ||
      !enteredDatacenterIsValid ||
      !enteredForgeCustomerIdIsValid ||
      !enteredRegionIsValid ||
      !enteredCountryIsValid ||
      (!isStateDisabled && !enteredStateIsValid) ||
      regexhasError ||
      regexhasErrorForge ||
      regexhasErrorHeadquater ||
      regexhasErrorOrgName ||
      regexhasErrorZipCode ||
      enteredApp.length == 0 ||
      !hasValidForgeCustomerId ||
      !isForgeCustomerIdRegexMatched
    ) {
      tenantSubmitHandler();
      enteredheadquarterAddressSubmitHandler();
      enteredCurrencySubmitHandler();
      enteredTimeZoneSubmitHandler();
      enteredDatacenterSubmitHandler();
      enteredForgeCustomerIdSubmitHandler();
      enteredCountrySubmitHandler();
      enteredRegionSubmitHandler();
      enteredZipcodeSubmitHandler();
      enteredOrganizationNameSubmitHandler();
      if (!isStateDisabled) {
        enteredStateSubmitHandler();
      }

      return;
    } else {
      setCreateOpen(true);
    }
  }

  const [regionMapping, setRegionMapping] = useState<Array<MappingRegion>>([]);
  const [countryMapping, setCountryMapping] = useState<Array<MappingCountry>>(
    []
  );
  const [stateMapping, setStateMapping] = useState<Array<MappingState>>([]);
  const [TimezoneMapping, setTimezoneMapping] = useState<
    Array<OptionsTimeZone>
  >([]);

  useEffect(() => {
    const newregionMapping: Array<MappingRegion> = [];
    optionsGeoMapping?.regionDataMap?.map((x) => {
      newregionMapping.push(x.region);
    });
    setRegionMapping(newregionMapping);
  }, [optionsGeoMapping]);

  useEffect(() => {
    let indexOfRegionData = optionsGeoMapping?.regionDataMap.findIndex(
      (x) => x.region.regionId === +enteredRegion
    );
    let countries: Array<MappingCountry> = [];
    let timezone: Array<OptionsTimeZone> = [];

    if (indexOfRegionData !== -1) {
      countries = optionsGeoMapping?.regionDataMap[indexOfRegionData].countries;
      timezone = optionsGeoMapping?.regionDataMap[indexOfRegionData].timezones;
      setCountryMapping(countries);
      setTimezoneMapping(timezone);
    }
  }, [enteredRegion]);

  useEffect(() => {
    let x1 = optionsGeoMapping?.countryDataMap.findIndex(
      (x) => x.country.countryId === +enteredCountry
    );
    let state: Array<MappingState> = [];

    if (x1 !== -1) {
      state = optionsGeoMapping?.countryDataMap[x1].states;
      setStateMapping(state);
    }
  }, [enteredCountry]);
  /**Returns true if the enetered Forge customer id is invalid */
  const isForgeCustomerIdValid = (errMsg: string) =>
    errMsg.replace(/\s/g, "").toLowerCase().includes("forgecustomerid");
  // istanbul ignore next
  //for handelling submit , on clicking on popup , after validation is true
  async function onSubmitHandeller(event: any) {
    event.preventDefault();
    if (enteredProduct.length == 0) {
      setIsTouched(true);
    }

    if (
      !enteredheadquarterAddressIsValid ||
      !enteredTenantNameIsValid ||
      !enteredCurrencyIsValid ||
      !enteredTimeZoneIsValid ||
      !enteredDatacenterIsValid ||
      !enteredForgeCustomerIdIsValid ||
      !enteredRegionIsValid ||
      !enteredCountryIsValid ||
      (!isStateDisabled && !enteredStateIsValid) ||
      enteredApp.length == 0 ||
      regexhasError ||
      regexhasErrorForge ||
      regexhasErrorHeadquater ||
      regexhasErrorOrgName ||
      regexhasErrorZipCode
    ) {
      tenantSubmitHandler();
      enteredheadquarterAddressSubmitHandler();
      enteredCurrencySubmitHandler();
      enteredTimeZoneSubmitHandler();
      enteredDatacenterSubmitHandler();
      enteredForgeCustomerIdSubmitHandler();
      enteredCountrySubmitHandler();
      enteredRegionSubmitHandler();
      if (!isStateDisabled) {
        enteredStateSubmitHandler();
      }
      enteredZipcodeSubmitHandler();
      enteredOrganizationNameSubmitHandler();
      setCreateOpen(false);
      return;
    }
    setCreateOpen(false);
    const tenantToCreate: CreateorEditTenantDto = {
      tenantName: enteredTenantName,
      headquarterAddress: enteredheadquarterAddress,
      timezone: enteredTimeZone,
      datacenter: enteredDatacenter as unknown as number,
      currency: enteredCurrency as unknown as number,
      applications: enteredApp,
      forgeCustomerId: enteredForgeCustomerId,
      region: enteredRegion as unknown as number,
      country: enteredCountry as unknown as number,
    };
    let zipCodeOfTenant = enteredZipcode as unknown as number;
    if (zipCodeOfTenant > 0) {
      tenantToCreate.zipcode = zipCodeOfTenant;
    }
    if (enteredOrganizationName !== "") {
      tenantToCreate.organizationName = enteredOrganizationName;
    }
    if (enteredState !== "" && !isStateDisabled) {
      tenantToCreate.state = +enteredState;
    }

    if (previewImage !== "") {
      setIsLoading(true);
      dispatch(createTenantDetails(tenantToCreate))
        .unwrap()

        .then((response) => {
          const parameters1: any = {
            tenantId: response.id,
            fileName: currentImage,
            progressBar: null,
          };

          dispatch(uploadTenantLogoDetails(parameters1))
            .then(() => {
              navigate("/tenant");
            })
            .catch((err) => {
              seterrorLogo(updateErrorList(err, [...errorLogo]));
              navigate("/tenant");
            });
        })
        .catch((err: any) => {
          if (isForgeCustomerIdValid(err?.data)) {
            setHasValidForgeCustomerId(false);
            setInvalidForgeCustomerId(enteredForgeCustomerId);
          }

          seterrorCreateCustomer(
            updateErrorList(err, [...errorCreateCustomer])
          );
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      setIsLoading(true);
      dispatch(createTenantDetails(tenantToCreate))
        .unwrap()
        .then(() => navigate("/tenant"))
        .catch((err: any) => {
          if (isForgeCustomerIdValid(err?.data)) {
            setHasValidForgeCustomerId(false);
            setInvalidForgeCustomerId(enteredForgeCustomerId);
          }

          seterrorCreateCustomer(
            updateErrorList(err, [...errorCreateCustomer])
          );
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }
  // istanbul ignore next
  //for ImageUpload submit , on clicking on edit image icon
  const ImageUpload: React.FC = () => {
    const selectImage = (event: React.ChangeEvent<HTMLInputElement>) => {
      const files = event.target.files as FileList;
      var allowedExtensions = /(\.jpg|\.jpeg|\.png|\.svg)$/i;
      if (!allowedExtensions.exec(files?.[0].name)) {
        alert("Invalid Logo file format, please select a Image file");
        return false;
      } else {
        const selectedFiles = event.target.files as FileList;
        setCurrentImage(selectedFiles?.[0]);
        setPreviewImage(URL.createObjectURL(selectedFiles?.[0]));
        setProgress(0);
      }
    };
    return (
      <div
        style={{
          display: "flex",
          alignItems: "flex-end",
          marginLeft: "-4vh",
          zIndex: 1,
        }}
      >
        <IconButton
          sx={{
            backgroundColor: "#101010",
            color: "white",
            height: "4vh",
            width: "4vh",
            borderBlockColor: "black",
            borderTop: "1vh",
            position: "relative",
            bottom: "0px",
          }}
          data-testid="imageEdit"
          onClick={handleIconClick}
        >
          <EditIcon fontSize="small" sx={{ fontSize: "1rem" }} />
        </IconButton>
        <input
          type="file"
          accept="image/*"
          ref={fileInputRef}
          onChange={selectImage}
          style={{ display: "none" }}
        />
        {currentImage && progress > 0 && (
          <div className="progress my-3">
            <div
              className="progress-bar progress-bar-info"
              role="progressbar"
              aria-valuenow={progress}
              aria-valuemin={0}
              aria-valuemax={100}
              style={{ width: progress + "%", color: "red" }}
            >
              {progress}%
              <LinearProgress variant="determinate" value={progress} />
            </div>
          </div>
        )}

        {message && (
          <div className="alert alert-secondary mt-3" role="alert">
            {message}
          </div>
        )}
        {imageInfos.length > 0 && (
          <div className="card mt-3">
            <div className="card-header">List of Images</div>
            <ul className="list-group list-group-flush">
              {imageInfos.map((img, index) => (
                <li className="list-group-item" key={index}>
                  <p>
                    <a href={img.url}>{img.name}</a>
                  </p>
                  <img src={img.url} alt={img.name} height="80px" />
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    );
  };
  const onDialogForServerCloseHandler = () => setOpenDialogServerError(false);
  const onDialogForNOURLCloseHandler = () => setOpenDialogNoURLError(false);

  const handleToastBarClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenToastError(false);
  };

  const hasInvalidForgeCustId = () => {
    if (!isForgeCustomerIdRegexMatched || !hasValidForgeCustomerId) {
      return true;
    } else {
      return false;
    }
  };

  /**To return a helper text */
  const getForgeCustomerIdHelperText = () => {
    let helperText = "This is a required field";
    if (!isForgeCustomerIdRegexMatched) {
      helperText =
        "Forge customer id can only contain alphabets, numbers, dots(.), commas(,) underscores(_) and hyphens(-)";
    } else if (!hasValidForgeCustomerId) {
      helperText = "Please enter a valid Forge customer id";
    } else {
    }

    return helperText;
  };

  return (
    <>
      <Paper className={classes.paper}>
        <form onSubmit={onSubmitHandeller}>
          <Grid
            container
            direction="row"
            p={1}
            sx={{ width: "100%", height: "auto" }}
          >
            <Grid
              item
              xs={12}
              sx={{ paddingBottom: 1, display: "flex", flexDirection: "row" }}
            >
              <Button
                onClick={backButtonHandler}
                sx={{
                  color: "#F0F0F0",
                  padding: "0vh 0vh 0.7vh 0vh",
                  fontSize: "1.1 rem",
                  justifyContent: "start",
                  minWidth: "1vw",
                  minHeight: "0.5vh",
                }}
                data-testid="arrow-back-icon"
              >
                <ArrowBackIosIcon sx={{ fontSize: "0.9 rem" }} />
              </Button>
              <Typography className={classes.mainheading}>
                Create New Tenant
              </Typography>
            </Grid>
            <Grid item xs={12} sx={{ height: "auto" }}>
              <Grid
                container
                direction="row"
                sx={{ width: "100%", height: "auto" }}
              >
                <Grid
                  item
                  p={2}
                  sx={{
                    backgroundColor: "red",
                    width: "33%",
                    background: "#272727",
                    border: "1px solid #101010",
                    boxShadow:
                      "1px 1px 1px rgba(0, 0, 0, 0.15), 1px 1px 1px rgba(0, 0, 0, 0.15)",
                    borderRadius: ".7vw",
                    height: "77vh",
                    minheight: "470px",
                    marginRight: "1vw",
                  }}
                >
                  <Typography className={classes.secondaryHeading}>
                    PROFILE INFORMATION
                  </Typography>
                  <Grid sx={{ marginBottom: "0vh" }}>
                    <Box
                      className={classes.AvatarBox}
                      sx={{
                        ...commonStyles,
                        backgroundImage: `url(${editLogo})`,
                      }}
                    >
                      {previewImage === "" ? (
                        <Avatar
                          data-testid="avatar"
                          sx={{
                            height: "13vh",
                            width: "13vh",
                            position: "flex",
                          }}
                          alt="Upload Logo"
                          src={editLogo}
                        />
                      ) : (
                        <Avatar
                          sx={{
                            height: "13vh",
                            width: "13vh",
                            position: "flex",
                          }}
                          alt="Upload Logo"
                          src={previewImage}
                        />
                      )}

                      <ImageUpload />
                    </Box>
                  </Grid>
                  {/* <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <Box sx={{ ...commonStyles, borderRadius: '50%' }} />
      </Box> */}
                  <Box
                    p={2}
                    className={classes.setBoxTextFields}

                    // sx={{ margin: "0.9vh", padding: "0px", paddingTop: "1vh" }}
                  >
                    <FormLabel className={classes.label}>
                      Tenant Name <div style={{ color: "red" }}> *</div>
                    </FormLabel>
                    <TextField
                      fullWidth
                      id="Tenant%_Name"
                      type="text"
                      size="small"
                      data-testid="Tenant_Name"
                      placeholder="Enter"
                      onBlur={tenantNameBlurHandler}
                      sx={{
                        "& .MuiFormHelperText-root": {
                          marginTop: 0.4,
                          lineHeight: 0.9,
                        },
                      }}
                      onChange={(event) =>
                        tenantNameChangeHandler(event, TenantNameRegex)
                      }
                      inputProps={{
                        maxLength: 32,
                        "data-testid": "Tenant_Name_test",
                      }}
                      value={enteredTenantName}
                      className={classes.textField}
                      {...((enteredTenantHasError ||
                        enteredTenantOnSubmitError ||
                        regexhasError) && {
                        error: true,
                        helperText: regexhasError
                          ? "Tenant name can only contain alphabets"
                          : "This is a required field",
                      })}
                    />
                  </Box>
                  <Box p={2} className={classes.setBoxTextFields}>
                    <FormLabel className={classes.label}>
                      Organization Name
                    </FormLabel>
                    <TextField
                      fullWidth
                      id="Org_Name"
                      type="text"
                      size="small"
                      placeholder="Enter"
                      data-testid="Org_Name"
                      onBlur={enteredOrganizationNameBlurHandler}
                      sx={{
                        "& .MuiFormHelperText-root": {
                          marginTop: 0.4,
                          lineHeight: 0.9,
                        },
                      }}
                      // onChange={enteredOrganizationNameChangeHandler}
                      onChange={(event) =>
                        enteredOrganizationNameChangeHandler(
                          event,
                          OrgNameRegex
                        )
                      }
                      {...(regexhasErrorOrgName && {
                        error: true,
                        helperText: regexhasErrorOrgName
                          ? "Organization name can only contain alphabets, dots(.) and hyphens(-) "
                          : "This is a required field",
                      })}
                      inputProps={{
                        maxLength: 32,
                        "data-testid": "Org_Name_test",
                      }}
                      value={enteredOrganizationName}
                      className={classes.textField}
                    />
                  </Box>
                  <Box p={2} className={classes.setBoxTextFields}>
                    <FormLabel className={classes.label}>
                      Headquarter Address<div style={{ color: "red" }}> *</div>
                    </FormLabel>
                    <TextField
                      fullWidth
                      id="HeadquarterAddress"
                      type="text"
                      placeholder="Enter"
                      data-testid="HeadquarterAddress"
                      size="small"
                      value={enteredheadquarterAddress}
                      sx={{
                        "& .MuiFormHelperText-root": {
                          marginTop: 0.4,
                          lineHeight: 0.9,
                          marginRight: 0,
                        },
                      }}
                      onBlur={enteredheadquarterAddressBlurHandler}
                      // onChange={enteredheadquarterAddressChangeHandler}
                      onChange={(event) =>
                        enteredheadquarterAddressChangeHandler(
                          event,
                          AddressRegex
                        )
                      }
                      inputProps={{
                        maxLength: 32,
                        "data-testid": "Address_test",
                      }}
                      className={classes.textField}
                      {...((enteredheadquarterAddressHasError ||
                        enteredheadquarterAddressOnSubmitError ||
                        regexhasErrorHeadquater) && {
                        error: true,
                        helperText: regexhasErrorHeadquater
                          ? "Address can only contain alphabets, numbers, dots(.) hyphens(-) and comma(,)"
                          : "This is a required field",
                      })}
                    />
                  </Box>
                  <Grid container>
                    <Grid item xs={6} md={6}>
                      <Box
                        sx={{ lineHeight: 0 }}
                        className={classes.setBoxTextFieldsNew}
                      >
                        <FormLabel className={classes.label}>
                          Region <div style={{ color: "red" }}> *</div>
                        </FormLabel>
                        <Select
                          displayEmpty
                          data-testid="selectedRegion"
                          input={<OutlinedInput />}
                          renderValue={(selected) => {
                            if (selected.length === 0) {
                              return (
                                <em className={classes.placeholder}>
                                  Select Region
                                </em>
                              );
                            }
                            return getRegionById(selected);
                          }}
                          fullWidth
                          labelId="region"
                          id="region"
                          value={enteredRegion}
                          size="small"
                          type="text"
                          onBlur={enteredRegionBlurHandler}
                          onChange={(event) => {
                            enteredRegionChangeHandler(event, /.*/);
                            // Enable country field after selecting "Region" field
                            setIsCountryDisabled(false);
                            setIsTimeZoneDisabled(false);
                            resetEnteredCountry();
                            resetEnteredTimeZone();
                            resetEnteredState();
                          }}
                          className={classes.dropdownNew}
                          {...((enteredRegionHasError ||
                            enteredRegionSubmitError) && {
                            error: true,
                          })}
                        >
                          {regionMapping?.map((optionsRegion: any) => (
                            <MenuItem
                              key={optionsRegion.regionId}
                              className={classes.dropdownNew}
                              value={optionsRegion.regionId}
                            >
                              {optionsRegion.regionName}
                            </MenuItem>
                          ))}
                        </Select>

                        {(enteredRegionHasError ||
                          enteredRegionSubmitError) && (
                          <FormHelperText className={classes.requiredText}>
                            This is a required field
                          </FormHelperText>
                        )}
                      </Box>
                    </Grid>
                    <Grid item xs={6} md={6} sx={{ margin: "0vh" }}>
                      <Box
                        className={classes.setBoxTextFieldsNew}
                        sx={{ lineHeight: 0 }}
                      >
                        <FormLabel className={classes.label}>
                          Country <div style={{ color: "red" }}> *</div>
                        </FormLabel>
                        <Tooltip
                          title={
                            isCountryDisabled
                              ? "Please select a region first"
                              : ""
                          }
                        >
                          <Select
                            fullWidth
                            labelId="countryName"
                            id="countryName"
                            data-testid="countryName"
                            disabled={isCountryDisabled}
                            value={enteredCountry}
                            size="small"
                            type="text"
                            onBlur={enteredCountryBlurHandler}
                            onChange={(event) => {
                              enteredCountryChangeHandler(event, /.*/);
                              resetEnteredState();
                              if (+event.target.value === 1) {
                                setIsStateDisabled(false);
                              } else {
                                setIsStateDisabled(true);
                              }
                            }}
                            className={classes.dropdown}
                            {...((enteredCountryHasError ||
                              enteredCountrySubmitError) && {
                              error: true,
                            })}
                            displayEmpty
                            input={<OutlinedInput />}
                            renderValue={(selected) => {
                              if (selected.length === 0) {
                                return (
                                  <em className={classes.placeholder}>
                                    Select Country
                                  </em>
                                );
                              }

                              return getCountryNameById(selected);
                            }}
                          >
                            {countryMapping?.map((optionsCountry) => (
                              <MenuItem
                                key={optionsCountry.countryId}
                                className={classes.dropdown}
                                value={optionsCountry.countryId}
                              >
                                {optionsCountry.countryName}
                              </MenuItem>
                            ))}
                          </Select>
                        </Tooltip>
                        {(enteredCountryHasError ||
                          enteredCountrySubmitError) && (
                          <FormHelperText className={classes.requiredText}>
                            This is a required field
                          </FormHelperText>
                        )}
                      </Box>
                    </Grid>
                  </Grid>
                  {/* </Grid> */}
                  <Grid container>
                    {+enteredCountry === 1 && (
                      <Grid item xs={6} md={6}>
                        <Box
                          sx={{ lineHeight: 0, margin: "0vh" }}
                          className={classes.setBoxTextFieldsNew}
                        >
                          {
                            <FormLabel className={classes.label}>
                              State <div style={{ color: "red" }}> *</div>
                            </FormLabel>
                          }

                          <Tooltip
                            title={
                              isStateDisabled && enteredCountry === "1"
                                ? "Please select a country first"
                                : ""
                            }
                          >
                            <Select
                              displayEmpty
                              data-testid="selectedState"
                              input={<OutlinedInput />}
                              renderValue={(selected) => {
                                if (selected.length === 0) {
                                  return (
                                    <em className={classes.placeholder}>
                                      Select State
                                    </em>
                                  );
                                }

                                return getStateById(selected);
                              }}
                              fullWidth
                              labelId="state"
                              id="state"
                              value={enteredState}
                              disabled={isStateDisabled}
                              size="small"
                              type="text"
                              onBlur={enteredStateBlurHandler}
                              onChange={(event) =>
                                enteredStateChangeHandler(event, /.*/)
                              }
                              className={classes.dropdownNew}
                              {...((enteredStateHasError ||
                                enteredStateSubmitError) &&
                                !isStateDisabled && {
                                  error: true,
                                })}
                            >
                              {stateMapping?.map(
                                (optionsState: MappingState) => (
                                  <MenuItem
                                    key={optionsState.stateId}
                                    className={classes.dropdownNew}
                                    value={optionsState.stateId}
                                  >
                                    {optionsState.stateName}
                                  </MenuItem>
                                )
                              )}
                            </Select>
                          </Tooltip>

                          {!isStateDisabled &&
                            (enteredStateHasError ||
                              enteredStateSubmitError) && (
                              <FormHelperText className={classes.requiredText}>
                                This is a required field
                              </FormHelperText>
                            )}
                        </Box>{" "}
                      </Grid>
                    )}
                    <Grid item xs={6} md={6} sx={{ margin: "0vh" }}>
                      <Box className={classes.setBoxTextFieldsNew}>
                        <FormLabel className={classes.label}>Zipcode</FormLabel>
                        <TextField
                          fullWidth
                          id="zipcode"
                          data-testid="selectZipcode"
                          type="text"
                          inputProps={{
                            inputMode: "numeric",
                            pattern: "[0-9]*",
                            maxLength: 6,
                          }}
                          size="small"
                          onKeyPress={(event) => {
                            const keyCode = event.keyCode || event.which;
                            const keyValue = String.fromCharCode(keyCode);

                            // Allow only numbers (0-9)
                            if (!/^[0-9]+$/.test(keyValue)) {
                              event.preventDefault();
                            }
                          }}
                          value={enteredZipcode}
                          placeholder="Enter"
                          onBlur={enteredZipcodeBlurHandler}
                          onChange={(event) =>
                            enteredZipcodeChangeHandler(event, /.*/)
                          }
                          {...(regexhasErrorZipCode && {
                            error: true,
                            helperText: regexhasErrorHeadquater
                              ? "This is not valid field"
                              : "This is a required field",
                          })}
                          className={classes.textField}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  item
                  p={2}
                  sx={{
                    width: "65.34%",
                    background: "#272727",
                    border: "1px solid #101010",
                    boxShadow:
                      "1px 1px 1px rgba(0, 0, 0, 0.15), 1px 1px 1px rgba(0, 0, 0, 0.15)",
                    borderRadius: ".7vw",
                    height: "77vh",
                    minheight: "470px",
                  }}
                >
                  <Typography className={classes.secondaryHeading}>
                    OTHER INFORMATION
                  </Typography>

                  <Grid container spacing={2}>
                    <Grid item xs={6} md={6}>
                      <Box className={classes.setBoxTextFieldsOther}>
                        <FormLabel className={classes.label}>
                          Forge Customer ID
                          <div style={{ color: "red" }}> *</div>
                        </FormLabel>
                        <TextField
                          data-testid="forgeTenantId"
                          fullWidth
                          id="forgeCustomerId"
                          type="text"
                          size="small"
                          placeholder="Enter"
                          value={enteredForgeCustomerId}
                          onBlur={enteredForgeCustomerIdBlurHandler}
                          sx={{
                            "& .MuiFormHelperText-root": {
                              marginTop: 0.4,
                              lineHeight: 0.9,
                            },
                          }}
                          inputProps={{
                            "data-testid": "ForgeID_test",
                          }}
                          onChange={(event) => {
                            enteredForgeCustomerIdChangeHandler(event, /.*/);

                            /**Retain helper text if invalid forge customer id not changed */
                            if (
                              event.target.value &&
                              event.target.value === invalidForgeCustomerId
                            ) {
                              setHasValidForgeCustomerId(false);
                            } else {
                              setHasValidForgeCustomerId(true);
                            }

                            /**Checking allowed characters */
                            if (
                              event.target.value &&
                              !forgeCustomerIdRegex.test(event.target.value)
                            ) {
                              setIsForgeCustomerIdRegexMatched(false);
                            } else {
                              setIsForgeCustomerIdRegexMatched(true);
                            }
                          }}
                          className={classes.textField}
                          {...((enteredForgeCustomerIdHasError ||
                            enteredForgeCustomerIdOnSubmitError ||
                            hasInvalidForgeCustId()) && {
                            error: true,
                            helperText: getForgeCustomerIdHelperText(),
                          })}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={6} md={6}>
                      <Box
                        className={classes.setBoxTextFieldsOther}
                        sx={{ lineHeight: 0 }}
                      >
                        <FormLabel className={classes.label}>
                          Tenant Currency <div style={{ color: "red" }}> *</div>
                        </FormLabel>
                        <Select
                          fullWidth
                          labelId="currency"
                          id="currency"
                          value={enteredCurrency}
                          size="small"
                          type="text"
                          data-testid="selectCurrency"
                          onBlur={enteredCurrencyBlurHandler}
                          // onChange={enteredCurrencyChangeHandler}
                          onChange={(event) =>
                            enteredCurrencyChangeHandler(event, /.*/)
                          }
                          displayEmpty
                          input={<OutlinedInput />}
                          renderValue={(selected) => {
                            if (selected.length === 0) {
                              return (
                                <em className={classes.placeholder}>
                                  Select Tenant Currency
                                </em>
                              );
                            }

                            return getCurrencyById(selected);
                          }}
                          className={classes.dropdownNew}
                          {...((enteredCurrencyHasError ||
                            enteredCurrencySubmitError) && {
                            error: true,
                          })}
                        >
                          {optionsCurrency?.map((optionsCurrencys) => (
                            <MenuItem
                              key={optionsCurrencys.currencyId}
                              value={optionsCurrencys.currencyId}
                              className={classes.dropdownNew}
                            >
                              {optionsCurrencys.currencyName}
                            </MenuItem>
                          ))}
                        </Select>
                        {(enteredCurrencyHasError ||
                          enteredCurrencySubmitError) && (
                          <FormHelperText className={classes.requiredText}>
                            This is a required field{" "}
                          </FormHelperText>
                        )}
                      </Box>
                    </Grid>
                    <Grid item xs={6} md={6}>
                      <Box className={classes.setBoxTextFieldsOther}>
                        <FormLabel className={classes.label}>
                          Tenant Data Center{" "}
                          <div style={{ color: "red" }}> *</div>
                        </FormLabel>
                        <Select
                          data-testid="selectDatacenterName"
                          fullWidth
                          labelId="datacenterName"
                          id="datacenterName"
                          value={enteredDatacenter}
                          size="small"
                          type="text"
                          onBlur={enteredDatacenterBlurHandler}
                          onChange={(event) =>
                            enteredDatacenterChangeHandler(event, /.*/)
                          }
                          className={classes.dropdown}
                          {...((enteredDatacenterHasError ||
                            enteredDatacenterSubmitError) && {
                            error: true,
                          })}
                          displayEmpty
                          input={<OutlinedInput />}
                          renderValue={(selected) => {
                            if (selected.length === 0) {
                              return (
                                <em className={classes.placeholder}>
                                  Select Tenant Data Center
                                </em>
                              );
                            }

                            return getDataCenterById(selected);
                          }}
                        >
                          {optionsDataCenter?.map((optionsDataCenters) => (
                            <MenuItem
                              key={optionsDataCenters.datacenterId}
                              className={classes.dropdown}
                              value={optionsDataCenters.datacenterId}
                            >
                              {optionsDataCenters.datacenterName}
                            </MenuItem>
                          ))}
                        </Select>
                        {(enteredDatacenterHasError ||
                          enteredDatacenterSubmitError) && (
                          <FormHelperText className={classes.requiredText}>
                            This is a required field
                          </FormHelperText>
                        )}
                      </Box>{" "}
                    </Grid>
                    <Grid item xs={6} md={6}>
                      <Box className={classes.setBoxTextFieldsOther}>
                        <FormLabel className={classes.label}>
                          Time Zone <div style={{ color: "red" }}> *</div>
                        </FormLabel>
                        <Tooltip
                          title={
                            isTimeZoneDisabled
                              ? "Please select a region first"
                              : ""
                          }
                        >
                          <Select
                            data-testid="selecttimezoneName"
                            fullWidth
                            labelId="timezoneName"
                            id="timezoneName"
                            value={enteredTimeZone}
                            disabled={isTimeZoneDisabled}
                            size="small"
                            type="text"
                            onBlur={enteredTimeZoneBlurHandler}
                            onChange={(event) =>
                              enteredTimeZoneChangeHandler(event, /.*/)
                            }
                            className={classes.dropdown}
                            {...((enteredTimeZoneHasError ||
                              enteredTimeZoneSubmitError) && {
                              error: true,
                            })}
                            displayEmpty
                            input={<OutlinedInput />}
                            renderValue={(selected) => {
                              if (selected.length === 0) {
                                return (
                                  <em className={classes.placeholder}>
                                    Select Time Zone
                                  </em>
                                );
                              }

                              return getTimeZoneById(selected);
                            }}
                          >
                            {TimezoneMapping?.map((optionstimeZones) => (
                              <MenuItem
                                key={optionstimeZones.timezoneId}
                                value={optionstimeZones.timezoneId}
                                className={classes.dropdown}
                              >
                                {optionstimeZones.timezoneName}
                              </MenuItem>
                            ))}
                          </Select>
                        </Tooltip>
                        {(enteredTimeZoneHasError ||
                          enteredTimeZoneSubmitError) && (
                          <FormHelperText className={classes.requiredText}>
                            This is a required field{" "}
                          </FormHelperText>
                        )}
                      </Box>
                    </Grid>
                    <Grid item xs={6} md={6}>
                      <Box className={classes.setBoxTextFieldsOther}>
                        <FormLabel className={classes.label}>
                          Select Product <div style={{ color: "red" }}> *</div>
                        </FormLabel>
                        <Autocomplete
                          data-testid="SelectProduct"
                          // sx={{
                          //   // "--Autocomplete-wrapperGap": "30px",
                          //   "--Chip-minHeight": "3px",
                          //   "& .MuiAutocomplete-listbox": {
                          //     padding: 0,
                          //     paddingTop: 0,
                          //   },
                          //   "& .MuiInputBase-input": {
                          //     height: "1em",
                          //   },
                          //   "& .MuiAutocomplete-tag ": {
                          //     backgroundColor: "#272727",
                          //     borderRadius: "5px",
                          //     height: "100%",
                          //     border: "1px solid #D0D0D0",
                          //   },
                          // }}
                          sx={{
                            "& .MuiFormHelperText-root": {
                              marginTop: 0.1,
                              lineHeight: 0.9,
                            },
                            // "--Autocomplete-wrapperGap": "30px",
                            "--Chip-minHeight": "3px",
                            "& .MuiAutocomplete-listbox": {
                              padding: 0,
                              paddingTop: 0,
                            },
                            "& .MuiInputBase-input": {
                              height: "1em",
                            },
                            "& .MuiAutocomplete-tag ": {
                              backgroundColor: "#272727",
                              borderRadius: "5px",
                              height: "100%",
                              border: "1px solid #D0D0D0",
                            },
                          }}
                          multiple
                          id="checkboxes-tags-demo"
                          options={optionsProduct}
                          disableCloseOnSelect
                          getOptionLabel={(option) => option.applicationName}
                          className={classes.dropdown}
                          onChange={handleApplicationSelection}
                          value={selectedApplications}
                          renderOption={(
                            props,
                            option: OptionsProduct,
                            { selected }: AutocompleteRenderOptionState
                          ) => {
                            const selectAllProps =
                              option?.applicationId === "selectAll"
                                ? { checked: allSelected }
                                : {};
                            return (
                              !allSelected && (
                                <li
                                  {...props}
                                  style={{
                                    alignItems: "center",
                                    paddingRight: 2,
                                  }}
                                  className={classes.dropdown}
                                >
                                  <Checkbox
                                    className={classes.dropdown}
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    checked={selected}
                                    {...selectAllProps}
                                  />
                                  {option.applicationName}
                                </li>
                              )
                            );
                          }}
                          renderInput={(params) => (
                            <TextField
                              className={classes.dropdown}
                              value={enteredApp}
                              onBlur={() => {
                                setIsTouched(true);
                              }}
                              {...(enteredApp.length === 0 &&
                                isTouched && {
                                  error: true,
                                })}
                              sx={{
                                "& .MuiFormHelperText-root": {
                                  marginTop: 0.1,
                                  lineHeight: 0.9,
                                },
                                "& .MuiAutocomplete-root .MuiInputBase-input": {
                                  height: "1em",
                                },
                              }}
                              placeholder={
                                selectedApplications.length === 0
                                  ? "Select Product"
                                  : ""
                              }
                              {...params}
                            />
                          )}
                        />
                        {enteredApp.length === 0 && isTouched && (
                          <FormHelperText className={classes.requiredText}>
                            This is a required field{" "}
                          </FormHelperText>
                        )}
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              backgroundColor: "#272727",
              width: "98%",
              border: "1px solid #101010",
              boxShadow:
                "1px 1px 1px rgba(0, 0, 0, 0.15), 1px 1px 1px rgba(0, 0, 0, 0.15)",
              // marginTop: ".1vh",
              display: "flex",
              position: "fixed",
              bottom: 1,
              height: "7vh",
            }}
          >
            <Grid sx={{ height: "5vh" }}>
              <Button
                color="primary"
                fullWidth
                sx={{
                  fontSize: 12,
                  padding: 2,
                  height: "1vh",
                  margin: "1vw",
                  position: "relative",
                }}
                className={classes.cancelButton}
                onClick={() => setCancelOpen(true)}
              >
                Cancel
              </Button>
              <Dialog
                open={cancelOpen}
                // onClose={()=>setCancelOpen(false)}
              >
                <DialogTitle
                  className={classes.dialogHeading}
                  id="dialog-title"
                >
                  Cancel
                  <IconButton
                    edge="end"
                    color="inherit"
                    onClick={() => setCancelOpen(false)}
                    aria-label="close"
                    sx={{ marginLeft: "auto" }}
                  >
                    <CloseIcon />
                  </IconButton>{" "}
                </DialogTitle>
                <DialogContent sx={{ backgroundColor: "#272727" }}>
                  <DialogContentText
                    sx={{ backgroundColor: "#272727" }}
                    className={classes.dialogInfo}
                  >
                    Do you want to cancel the Tenant creation?
                  </DialogContentText>
                </DialogContent>
                <DialogActions
                  sx={{
                    backgroundColor: "#272727",
                    paddingRight: 4,
                    paddingBottom: 4,
                  }}
                >
                  <Button
                    className={classes.dialogCancelButton}
                    onClick={() => setCancelOpen(false)}
                  >
                    Cancel
                  </Button>
                  <Button
                    className={classes.dialogCreateButton}
                    autoFocus
                    onClick={confirmCancelHandller}
                  >
                    Confirm
                  </Button>
                </DialogActions>
              </Dialog>
            </Grid>
            <Grid
              container
              justifyContent="flex-end"
              sx={{ height: "5vh", paddingRight: "1.5vw" }}
            >
              <Button
                sx={{
                  fontSize: 12,
                  padding: 2,
                  height: "1vh",
                  position: "relative",
                  margin: "1vw",
                }}
                className={classes.createButton}
                variant="contained"
                {...(checkIfAnyTextFilled() && { disabled: false })}
                onClick={validate}
              >
                Create
              </Button>
              <Dialog open={createOpen} onClose={() => setCreateOpen(false)}>
                <DialogTitle
                  className={classes.dialogHeading}
                  id="dialog-title"
                >
                  Create Tenant
                  <IconButton
                    edge="end"
                    color="inherit"
                    onClick={() => setCreateOpen(false)}
                    aria-label="close"
                    sx={{ marginLeft: "auto" }}
                  >
                    <CloseIcon />
                  </IconButton>{" "}
                </DialogTitle>
                <DialogContent sx={{ backgroundColor: "#272727" }}>
                  <DialogContentText
                    sx={{ backgroundColor: "#272727" }}
                    className={classes.dialogInfo}
                  >
                    Do you want to create this Tenant?
                  </DialogContentText>
                </DialogContent>
                <DialogActions
                  sx={{
                    backgroundColor: "#272727",
                    paddingRight: 4,
                    paddingBottom: 4,
                  }}
                >
                  <Button
                    className={classes.dialogCancelButton}
                    onClick={() => setCreateOpen(false)}
                  >
                    Cancel
                  </Button>
                  <Button
                    className={classes.dialogCreateButton}
                    onClick={onSubmitHandeller}
                    type="submit"
                  >
                    Confirm
                  </Button>
                </DialogActions>
              </Dialog>
            </Grid>
          </Grid>
        </form>
      </Paper>
      {isLoading && <Loader />}
      {/* // Add Toast
      bar component and pass onClose for alert and open, onClose for snackbar //
      Add Dialog component and pass open, onClose for Dialog */}

      {openDialogServerError && (
        <DialogForError
          open={openDialogServerError}
          onClose={onDialogForServerCloseHandler}
          errorList={errorList}
          errorType="serverError"
          data-testid="DialogForError"
        />
      )}
      {/* /// Open NoURL error */}
      {openDialogNoURLError && (
        <DialogForError
          open={openDialogNoURLError}
          onClose={onDialogForNOURLCloseHandler}
          errorList={errorList}
          errorType="noURLFoundError"
        />
      )}
      {/* /// Open Toast error */}
      {openToastError && (
        <ToastBarForError
          open={openToastError}
          onClose={handleToastBarClose}
          errorList={errorList}
        />
      )}
    </>
  );
}

export default CreateTenantPage;
